import { format } from 'date-fns';

const toFormatedDateTime = (dateTime: string | undefined | null): string =>
  dateTime ? format(new Date(dateTime), 'MMMM d, yyyy h:mm a') : '';

const toFormatedDate = (dateTime: string | undefined | null): string =>
  dateTime ? format(new Date(dateTime), 'MMMM d, yyyy') : '';

export { toFormatedDateTime, toFormatedDate };
